import consumer from "./consumer"

consumer.subscriptions.create("SampleRequestChannel", {
    connected() {
    },

    received(data) {
        if (data.status === 'accepted' || data.status === 'rejected') {
            const acceptButton = document.getElementById(`sample-request-message-action-${data.deal_sample_request_id}-accept`);
            const rejectButton = document.getElementById(`sample-request-message-action-${data.deal_sample_request_id}-reject`);

            acceptButton.disabled = true;
            rejectButton.disabled = true;
        }

        if (data.status === 'samples_shipped') {
            const trackingButton = document.getElementById(`sample-request-message-action-${data.deal_sample_request_id}-add-tracking-information`);
            trackingButton.disabled = true;
        }
    }
});
